export default {
  business: null,
  businessCurrency: [
    {
      name: "Soles",
      code: "PEN",
      symbol: "S/",
    },
    {
      name: "Dólar estadounidense",
      code: "USD",
      symbol: "$",
    },
    {
      name: "Peso mexicano",
      code: "MXN",
      symbol: "$",
    },
    {
      name: "Peso argentino",
      code: "ARS",
      symbol: "$",
    },
    {
      name: "Peso chileno",
      code: "CLP",
      symbol: "$",
    },
    {
      name: "Peso colombiano",
      code: "COP",
      symbol: "$",
    },
    {
      name: "Balboa Panameño",
      code: "PAB",
      symbol: "B/",
    },
    {
      name: "Euro",
      code: "EUR",
      symbol: "€",
    },
  ],
  landingPage: null,
  landingPages: null,
  ecommerce: null,
  embedForm: null,
  embedForms: null,
  linkPage: null,
  linkPages: null,
  customForm: null,
  customForms: null,
  specialFields: null,
  faq: null,
  faqs: null,
};
